export default {
      id: "icon-follow-link-usage",
      viewBox: "-4 -4 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-follow-link",
      toString: function () {
        return this.url;
      }
    }